<template>
	<div class="situation-info">
		<div class="title">
			<span>基地动态</span>
		</div>
		<el-divider></el-divider>
		<div v-for="item in showDate()" :key="item.id" class="item-dongtai">
			<el-row>
				<el-col :span="2">
					<div class="dd">{{item.dd}}</div>
					<div class="yymm">{{item.yymm}}</div>
				</el-col>
				<el-col :span="22">
					<div class="item-title" @click='openNews(item)'>
						{{item.title}}
					</div>
					<div class="item-info">
						{{item.info}}
					</div>
				</el-col>
			</el-row>
		</div>
		<el-pagination background layout="total, sizes, prev, pager, next, jumper" :total="tableDataCount" class="pagination" @size-change="sizeChange" @current-change="currentChange">
		</el-pagination>
	</div>
</template>

<script>
	import news from '@/assets/news.js'

	export default {
		data() {
			return {
				newsList: [],
				page_size: 10,
				page_current: 1,
				tableDataCount: 0,
			}
		},
		created() {
			news.reverse()
			this.newsList = news
			let id = this.$route.query.id
			if (id) {
				this.newsList.map(item => {
					if (item.id  == id) {
						this.openNews(item)
					}
				})
			}
		},
		methods: {
			sizeChange(e) {
				this.page_size = e
			},
			currentChange(e) {
				this.page_current = e
			},
			showDate() {
				if (this.newsList) {
					this.tableDataCount = this.newsList.length
					return this.newsList.slice((this.page_current - 1) * this.page_size, this.page_current * this.page_size)
				}
			},
			openNews(val) {
				this.$emit('openNews_details', val)
				// this.$emit('openNews_details', 1)
			}
		}
	}
</script>

<style lang="scss">
	.situation-info {

		.title {
			line-height: 50px;
			font-weight: bold;
		}

		.el-divider {
			margin: 0;
			margin-bottom: 20px;
		}

		.item-dongtai {
			border-bottom: 1px solid #d0cccc;
			padding: 10px 0;

			.yymm {
				text-align: center;
				font-size: 14px;
				color: #888888;
			}

			.dd {
				font-size: 30px;
				color: #333333;
				text-align: center;
			}

			.item-title {
				font-size: 16px;
				font-weight: 700;
				line-height: 30px;
				cursor: pointer;

				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
			}

			.item-info {
				font-size: 14px;
				color: #666666;

				white-space: nowrap;
				overflow: hidden;
				text-overflow: ellipsis;
			}
		}

		.pagination {
			text-align: center;
			padding-top: 20px;
		}
	}
</style>